module.exports = __webpack_public_path__ + "static/media/priscilla-du-preez-W3SEyZODn8U-unsplash.09ace5f8.jpg";